import React, {useEffect, useState} from 'react';
import { H1, UserContainer, UsersTable, UsersTableBody, UsersTableHead, UsersTableHeadColumn,UsersTableBodyColumn, UsersTableRow, Pill } from './style';
import axios from 'axios';
import AuthService from '../../../AuthService';
import Button from '../../../Components/Miscellaneous/Button';
import { FiEdit, FiUser, FiMail, FiPhone, FiShield, FiSearch, FiX } from "react-icons/fi";
import { BiUserPlus } from 'react-icons/bi';
import { PaginationButton, PaginationContainer } from '../../Categories/style';
import Modal from '../../../Components/Miscellaneous/Modal';
import { Loader } from '../../Login/style';
import { toast } from 'react-toastify';
import Select from 'react-select';

export default function Users() {

    const [users, setUsers] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalUsers, setTotalUsers] = useState(0);
    const [loading, setLoading] = useState(true);

    // Filtros
    const [searchTerm, setSearchTerm] = useState('');
    const [filterStatus, setFilterStatus] = useState('all'); // all, active, inactive
    const [filterRole, setFilterRole] = useState('');
    const [filterOrganization, setFilterOrganization] = useState('');
    const [limit, setLimit] = useState(50);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0
    });

    useEffect(() => {
        fetchUsers();
    }, [currentPage, filterStatus, filterRole, filterOrganization, limit]);

    useEffect(() => {
        // Debounce search
        const timer = setTimeout(() => {
            if (currentPage === 1) {
                fetchUsers();
            } else {
                setCurrentPage(1);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [searchTerm]);

    const fetchUsers = () => {
        setLoading(true);

        // Construir query params
        const params = new URLSearchParams({
            page: currentPage,
            limit: limit
        });

        if (searchTerm) {
            params.append('search', searchTerm);
        }
        if (filterStatus === 'active') {
            params.append('isVerified', 'true');
        } else if (filterStatus === 'inactive') {
            params.append('isVerified', 'false');
        }
        if (filterRole) {
            params.append('role', filterRole);
        }
        if (filterOrganization) {
            params.append('organization', filterOrganization);
        }

        axios.get(`https://api.rb.beeapp.es/admin/users?${params.toString()}`, {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => {
            setUsers(response.data.results);
            setTotalPages(response.data.pagination.totalPages);
            setCurrentPage(response.data.pagination.currentPage);
            setTotalUsers(response.data.pagination.totalUsers);
            setLoading(false);

            // Fetch stats (siempre obtener totales sin filtros)
            fetchStats();
        })
        .catch(error => {
            console.error(error);
            toast.error('Error al cargar usuarios');
            setLoading(false);
        });
    };

    const fetchStats = () => {
        // Obtener estadísticas totales sin filtros
        axios.get('https://api.rb.beeapp.es/admin/users?limit=1', {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => {
            setStats(prev => ({
                ...prev,
                total: response.data.pagination.totalUsers
            }));
        });

        // Obtener usuarios activos
        axios.get('https://api.rb.beeapp.es/admin/users?limit=1&isVerified=true', {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => {
            setStats(prev => ({
                ...prev,
                active: response.data.pagination.totalUsers
            }));
        });

        // Obtener usuarios inactivos
        axios.get('https://api.rb.beeapp.es/admin/users?limit=1&isVerified=false', {
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => {
            setStats(prev => ({
                ...prev,
                inactive: response.data.pagination.totalUsers
            }));
        });
    };

    const clearFilters = () => {
        setSearchTerm('');
        setFilterStatus('all');
        setFilterRole('');
        setFilterOrganization('');
        setCurrentPage(1);
    };

    const roleOptions = [
        { value: '', label: 'Todos los roles' },
        { value: 'Admin', label: 'Admin' },
        { value: 'BeeAdmin', label: 'BeeAdmin' },
        { value: 'Client', label: 'Cliente' },
        { value: 'Distributor', label: 'Distribuidor' }
    ];

    const organizationOptions = [
        { value: '', label: 'Todas las organizaciones' },
        { value: 'DistribucionesRB', label: 'DistribucionesRB' },
        { value: 'BarOffice', label: 'BarOffice' }
    ];

    return (
        <>
        {loading && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.3)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100,
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    padding: '32px',
                    borderRadius: '12px',
                    width: 'auto',
                    textAlign: 'center',
                }}>
                    <Loader />
                    <p style={{
                        marginTop: '16px',
                        color: '#6b7280',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        Cargando usuarios...
                    </p>
                </div>
            </div>
        )}

        <div style={{
            padding: '24px',
            maxWidth: '1400px',
            margin: 'auto'
        }}>
            {/* Header Section */}
            <div style={{
                marginBottom: '32px'
            }}>
                <H1 style={{ marginBottom: '8px' }}>Gestión de Usuarios</H1>
                <p style={{
                    color: '#6b7280',
                    fontSize: '14px',
                    margin: 0,
                    fontFamily: 'Inter, sans-serif'
                }}>
                    Administra los usuarios registrados en el sistema
                </p>
            </div>

            {/* Filters and Actions */}
            <div style={{
                backgroundColor: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '24px'
            }}>
                {/* Search and filters row */}
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    flexWrap: 'wrap',
                    marginBottom: '16px'
                }}>
                    {/* Search Input */}
                    <div style={{ flex: '1', minWidth: '250px', position: 'relative' }}>
                        <FiSearch style={{
                            position: 'absolute',
                            left: '12px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#9ca3af',
                            pointerEvents: 'none'
                        }} size={16} />
                        <input
                            type="text"
                            placeholder="Buscar por nombre, email, CIF..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '10px 16px 10px 36px',
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontFamily: 'Inter, sans-serif',
                                outline: 'none',
                                transition: 'all 0.2s ease'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#028322'}
                            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                        />
                    </div>

                    {/* Role Filter */}
                    <div style={{ minWidth: '180px' }}>
                        <Select
                            value={roleOptions.find(opt => opt.value === filterRole)}
                            onChange={(option) => setFilterRole(option.value)}
                            options={roleOptions}
                            placeholder="Filtrar por rol"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    fontFamily: 'Inter, sans-serif',
                                    borderColor: '#e5e7eb',
                                    minHeight: '42px'
                                })
                            }}
                        />
                    </div>

                    {/* Organization Filter */}
                    <div style={{ minWidth: '200px' }}>
                        <Select
                            value={organizationOptions.find(opt => opt.value === filterOrganization)}
                            onChange={(option) => setFilterOrganization(option.value)}
                            options={organizationOptions}
                            placeholder="Filtrar por organización"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    fontSize: '14px',
                                    fontFamily: 'Inter, sans-serif',
                                    borderColor: '#e5e7eb',
                                    minHeight: '42px'
                                })
                            }}
                        />
                    </div>

                    {/* Clear Filters */}
                    {(searchTerm || filterRole || filterOrganization || filterStatus !== 'all') && (
                        <button
                            onClick={clearFilters}
                            style={{
                                padding: '10px 16px',
                                backgroundColor: '#fff',
                                color: '#dc2626',
                                border: '1px solid #dc2626',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                fontFamily: 'Inter, sans-serif',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#dc2626';
                                e.target.style.color = '#fff';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.color = '#dc2626';
                            }}
                        >
                            <FiX size={16} />
                            Limpiar filtros
                        </button>
                    )}
                </div>

                {/* Status Filter Buttons */}
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                        onClick={() => setFilterStatus('all')}
                        style={{
                            padding: '10px 16px',
                            backgroundColor: filterStatus === 'all' ? '#028322' : '#fff',
                            color: filterStatus === 'all' ? '#fff' : '#374151',
                            border: `1px solid ${filterStatus === 'all' ? '#028322' : '#e5e7eb'}`,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            fontFamily: 'Inter, sans-serif',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Todos ({stats.total})
                    </button>
                    <button
                        onClick={() => setFilterStatus('active')}
                        style={{
                            padding: '10px 16px',
                            backgroundColor: filterStatus === 'active' ? '#16a34a' : '#fff',
                            color: filterStatus === 'active' ? '#fff' : '#374151',
                            border: `1px solid ${filterStatus === 'active' ? '#16a34a' : '#e5e7eb'}`,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            fontFamily: 'Inter, sans-serif',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Activos ({stats.active})
                    </button>
                    <button
                        onClick={() => setFilterStatus('inactive')}
                        style={{
                            padding: '10px 16px',
                            backgroundColor: filterStatus === 'inactive' ? '#dc2626' : '#fff',
                            color: filterStatus === 'inactive' ? '#fff' : '#374151',
                            border: `1px solid ${filterStatus === 'inactive' ? '#dc2626' : '#e5e7eb'}`,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            fontFamily: 'Inter, sans-serif',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Inactivos ({stats.inactive})
                    </button>
                </div>
            </div>

            {/* Stats Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '16px',
                marginBottom: '24px'
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #028322',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px'
                }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: '#f0fdf4',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <FiUser size={24} color="#028322" />
                    </div>
                    <div>
                        <p style={{ margin: 0, fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                            Total Usuarios
                        </p>
                        <p style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                            {stats.total}
                        </p>
                    </div>
                </div>

                <div style={{
                    backgroundColor: '#fff',
                    border: '2px solid #16a34a',
                    borderRadius: '12px',
                    padding: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px'
                }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        backgroundColor: '#dcfce7',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <FiShield size={24} color="#16a34a" />
                    </div>
                    <div>
                        <p style={{ margin: 0, fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, sans-serif' }}>
                            Usuarios Activos
                        </p>
                        <p style={{ margin: 0, fontSize: '24px', fontWeight: '600', color: '#111827', fontFamily: 'Inter, sans-serif' }}>
                            {stats.active}
                        </p>
                    </div>
                </div>
            </div>

            {/* Users Table */}
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                overflow: 'auto',
                maxWidth: '100%'
            }}>
                <UsersTable>
                    <UsersTableHead>
                        <UsersTableRow>
                            <UsersTableHeadColumn style={{ minWidth: '110px' }}>CIF</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '150px' }}>Nombre</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '150px' }}>Apellido</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '220px' }}>Email</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '140px' }}>Teléfono</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '100px' }}>Estado</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '90px' }}>Rol</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '140px' }}>Organización</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ minWidth: '110px' }}>Acciones</UsersTableHeadColumn>
                        </UsersTableRow>
                    </UsersTableHead>
                    <UsersTableBody>
                    {users.length !== 0 ? users.map((user, index) => (
                        <UsersTableRow key={index}>
                            <UsersTableBodyColumn style={{ minWidth: '110px' }}>
                                <span style={{
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    color: '#6b7280'
                                }}>
                                    {user.CIF || '-'}
                                </span>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '150px' }}>
                                <span style={{ fontWeight: '500', color: '#111827', fontSize: '13px' }}>
                                    {user.Name}
                                </span>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '150px', fontSize: '13px' }}>
                                {user.Surname}
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '220px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <FiMail size={13} color="#6b7280" style={{ flexShrink: 0 }} />
                                    <span style={{ fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {user.Email}
                                    </span>
                                </div>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '140px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <FiPhone size={13} color="#6b7280" style={{ flexShrink: 0 }} />
                                    <span style={{ fontSize: '12px' }}>{user.Phone || '-'}</span>
                                </div>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '100px' }}>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    backgroundColor: user.isVerified ? '#dcfce7' : '#fee2e2',
                                    color: user.isVerified ? '#16a34a' : '#dc2626',
                                    fontFamily: 'Inter, sans-serif',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {user.isVerified ? 'Activo' : 'Inactivo'}
                                </span>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '90px' }}>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '4px 8px',
                                    borderRadius: '6px',
                                    fontSize: '11px',
                                    fontWeight: '500',
                                    backgroundColor: '#f3f4f6',
                                    color: '#374151',
                                    fontFamily: 'Inter, sans-serif',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {user.role || 'Client'}
                                </span>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '140px' }}>
                                <span style={{
                                    display: 'inline-block',
                                    padding: '4px 10px',
                                    borderRadius: '6px',
                                    fontSize: '11px',
                                    fontWeight: '500',
                                    backgroundColor: user.organization === 'BarOffice' ? '#dbeafe' : '#f0fdf4',
                                    color: user.organization === 'BarOffice' ? '#1e40af' : '#028322',
                                    fontFamily: 'Inter, sans-serif',
                                    whiteSpace: 'nowrap'
                                }}>
                                    {user.organization || 'DistribucionesRB'}
                                </span>
                            </UsersTableBodyColumn>
                            <UsersTableBodyColumn style={{ minWidth: '110px' }}>
                                <button
                                    onClick={() => window.location.href = `/admin/user-edit/${user._id}`}
                                    style={{
                                        padding: '6px 10px',
                                        backgroundColor: '#028322',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        fontFamily: 'Inter, sans-serif',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        transition: 'all 0.2s ease',
                                        whiteSpace: 'nowrap'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#026d1b'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#028322'}
                                >
                                    <FiEdit size={13} />
                                    Editar
                                </button>
                            </UsersTableBodyColumn>
                        </UsersTableRow>
                    )) : (
                        <UsersTableRow>
                            <UsersTableBodyColumn colSpan="9" style={{
                                textAlign: 'center',
                                padding: '40px',
                                color: '#9ca3af'
                            }}>
                                {searchTerm || filterStatus !== 'all' || filterRole || filterOrganization
                                    ? 'No se encontraron usuarios con los filtros aplicados'
                                    : 'No hay usuarios registrados'}
                            </UsersTableBodyColumn>
                        </UsersTableRow>
                    )}
                    </UsersTableBody>
                </UsersTable>
            </div>

            {/* Pagination and Results count */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '24px',
                flexWrap: 'wrap',
                gap: '16px'
            }}>
                {/* Results count */}
                <p style={{
                    margin: 0,
                    color: '#6b7280',
                    fontSize: '14px',
                    fontFamily: 'Inter, sans-serif'
                }}>
                    Mostrando {((currentPage - 1) * limit) + 1} - {Math.min(currentPage * limit, totalUsers)} de {totalUsers} usuarios
                </p>

                {/* Pagination */}
                {totalPages > 1 && (
                    <PaginationContainer>
                        <PaginationButton
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(1)}
                            style={{
                                opacity: currentPage === 1 ? 0.5 : 1,
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {'<<'}
                        </PaginationButton>
                        <PaginationButton
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            style={{
                                opacity: currentPage === 1 ? 0.5 : 1,
                                cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {'<'}
                        </PaginationButton>

                        {/* Páginas visibles */}
                        {[...Array(Math.min(5, totalPages))].map((_, i) => {
                            let pageNum;
                            if (totalPages <= 5) {
                                pageNum = i + 1;
                            } else if (currentPage <= 3) {
                                pageNum = i + 1;
                            } else if (currentPage >= totalPages - 2) {
                                pageNum = totalPages - 4 + i;
                            } else {
                                pageNum = currentPage - 2 + i;
                            }

                            return (
                                <PaginationButton
                                    key={pageNum}
                                    onClick={() => setCurrentPage(pageNum)}
                                    style={{
                                        backgroundColor: currentPage === pageNum ? '#028322' : '#fff',
                                        color: currentPage === pageNum ? '#fff' : '#374151',
                                        borderColor: currentPage === pageNum ? '#028322' : '#e5e7eb',
                                        fontWeight: currentPage === pageNum ? '600' : '400'
                                    }}
                                >
                                    {pageNum}
                                </PaginationButton>
                            );
                        })}

                        <PaginationButton
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                            style={{
                                opacity: currentPage === totalPages ? 0.5 : 1,
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {'>'}
                        </PaginationButton>
                        <PaginationButton
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(totalPages)}
                            style={{
                                opacity: currentPage === totalPages ? 0.5 : 1,
                                cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {'>>'}
                        </PaginationButton>
                    </PaginationContainer>
                )}

                {/* Items per page selector */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    <span style={{
                        color: '#6b7280',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        Por página:
                    </span>
                    <select
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        style={{
                            padding: '6px 12px',
                            border: '1px solid #e5e7eb',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontFamily: 'Inter, sans-serif',
                            outline: 'none',
                            cursor: 'pointer'
                        }}
                    >
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={200}>200</option>
                    </select>
                </div>
            </div>
        </div>
        </>
    )
}
